import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Packages from './components/Packages';
import Destinations from './components/Destinations';
import Testimonials from './components/Testimonials';


export default function App() {
  return (
    <div className="bg-white text-gray-800">
      <Navbar />
      <Hero />
      <About />
      <Packages/>
      <Destinations/>
      <Testimonials/>
      <Contact />
      <Footer />
    </div>
  );
}
